//
import Model from '@/models/Model'

/**
 * @class
 */
export default class ASent extends Model {
    /**
     * @description
     */
    resource() {
        return 'sent'
    }
}
